import { useRef, useState } from 'react';

import { Box, Button, Input } from '@betterment/samba-react';
import { useFormikContext } from 'formik';

import type { SystemStyleObject } from '@betterment/samba-styled-system/types';

interface FormikFileUploadProps {
  name: string;
  acceptedFileTypes?: string;
  css?: SystemStyleObject;
  onChange?: (file: File | null) => void;
}

export const FormikFileUpload = ({ name, acceptedFileTypes, css, onChange }: FormikFileUploadProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [fileName, setFileName] = useState('');
  const { setFieldValue, isSubmitting } = useFormikContext();

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null;
    setFileName(file?.name || '');
    void setFieldValue(name, file);
    onChange?.(file);
  };

  const handleBrowseClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <Box css={{ position: 'relative', ...css }}>
      <Input
        name={`${name}-display`}
        type="text"
        value={fileName}
        readOnly={true}
        disabled={isSubmitting}
        css={{
          width: '100%',
          paddingRight: '100px',
          '&[data-readonly=true]': {
            bg: 'background.surface',
          },
        }}
      />
      <Button
        type="button"
        variant="textPrimary"
        onClick={handleBrowseClick}
        disabled={isSubmitting}
        css={{
          position: 'absolute',
          right: '8px',
          top: '50%',
          transform: 'translateY(-50%)',
        }}
      >
        Browse
      </Button>
      <input
        ref={fileInputRef}
        type="file"
        accept={acceptedFileTypes}
        onChange={handleFileChange}
        data-testid={`${name}-file-input`}
        style={{ display: 'none' }}
      />
    </Box>
  );
};
